import { message } from "antd";
import { CUSTOMER_CLAIM } from "../configs/api-paths";
import BaseService from "./base/BaseService";
import { fetchProtectedResource, fetchResource } from "../utilities";

/**
 * Service dealing with Claims.
 */
class ClaimDocumentService extends BaseService {
	deleteClaimDocument = async (claimDocumentId) => {
		const deleteFile = {
			claimDocumentId: claimDocumentId,
			deletedBy: "test",
		};

		let hideLoadingMessage = message.loading("Deleting file...", 0);

		try {
			await fetchResource(CUSTOMER_CLAIM, {
				method: "PATCH",
				body: getFormData(deleteFile),
			});
			hideLoadingMessage();
			message.success("Successfully deleted file", 5);
			return true;
		} catch (error) {
			hideLoadingMessage();
			message.error(`Failed deleting file`, 5);
			return false;
		}
	};

	downloadClaimDocument = async (documentName) => {
		let hideLoadingMessage = message.loading("Downloading...", 0);

		try {
			const url = `${CUSTOMER_CLAIM}?fileName=${documentName}`;
			// GET
			await fetchProtectedResource(url).then((response) => {
				response.blob().then((blob) => {
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement("a");
					a.href = url;
					a.download = documentName;
					a.click();
				});
				hideLoadingMessage();
			});
		} catch (error) {
			hideLoadingMessage();
			message.error(
				`Failed downloading claim document file ${documentName}. Error: ${error}`,
				10
			);
		}
	};
}

function getFormData(object) {
	const formData = new FormData();
	Object.keys(object).forEach((key) => formData.append(key, object[key]));
	return formData;
}

export default ClaimDocumentService;
